import { IconButton } from '@breezeventures/ui-kit/icon-button';
import { Icon } from '@breezeventures/ui-kit/next/icon';

import {
  BusinessSelect,
  StatusSelect,
  StoreSelect,
} from './orders-filter-fields';

type Props = {
  onFiltersChange: () => void;
  onReset: () => void;
};

export function OrdersFilters({ onFiltersChange, onReset }: Props) {
  return (
    <div
      className={`
        grid grid-cols-[repeat(3,minmax(180px,1fr))_auto] items-center gap-2
      `}
    >
      <BusinessSelect onChange={onFiltersChange} />
      <StoreSelect onChange={onFiltersChange} />
      <StatusSelect onChange={onFiltersChange} />

      <IconButton
        type="button"
        variant="secondary"
        size="l"
        aria-label="Reset filters"
        onClick={onReset}
      >
        <Icon name="cross-s" size={24} version="v1" />
      </IconButton>
    </div>
  );
}
